var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFileCopy = function SvgFileCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#3ABCA8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "file_copy_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#file_copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 19H8c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 6 17V3c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 8 1h6.175a1.975 1.975 0 0 1 1.4.575l4.85 4.85a1.975 1.975 0 0 1 .575 1.4V17c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 19Zm0-11h-3.5c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0 1 14 6.5V3H8v14h11V8ZM4 23c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 21V8c0-.283.096-.52.288-.713A.968.968 0 0 1 3 7c.283 0 .52.096.712.287.192.192.288.43.288.713v13h10c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0 1 14 23H4Z"
  }))));
};

export default SvgFileCopy;